/* SHOP-122: scoped gallery, with keyboard tabs and click-to-load video. */
if (!customElements.get('wacc-equipment-gallery')) {
  customElements.define('wacc-equipment-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-equipment-thumb]'));
      this.panels = Array.from(this.querySelectorAll('[data-equipment-panel]'));
      this.dialog = this.querySelector('dialog');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', (event) => {
          const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: this.tabs.length - 1 }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          const selected = (next + this.tabs.length) % this.tabs.length;
          this.select(selected);
          this.tabs[selected].focus();
        }, options);
      });
      this.querySelectorAll('[data-equipment-play]').forEach((button) => {
        button.addEventListener('click', () => {
          const panel = button.closest('[data-equipment-panel]');
          panel.querySelector('[data-equipment-player]').replaceChildren(panel.querySelector('template').content.cloneNode(true));
          const video = panel.querySelector('video');
          const captions = panel.querySelector('[data-equipment-captions]');
          if (video && captions) {
            const track = document.createElement('track');
            track.kind = 'subtitles';
            track.srclang = 'en';
            track.label = 'English';
            track.default = true;
            panel.captionUrl = URL.createObjectURL(new Blob([JSON.parse(captions.textContent)], { type: 'text/vtt' }));
            track.src = panel.captionUrl;
            video.append(track);
          }
          button.hidden = true;
          const player = panel.querySelector('video, iframe');
          if (player) {
            player.tabIndex = 0;
            player.focus();
          }
        }, options);
      });
      this.querySelectorAll('[data-equipment-zoom]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!this.dialog?.showModal) return;
          event.preventDefault();
          this.zoomTrigger = link;
          const image = link.querySelector('img').cloneNode();
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = link.href;
          image.loading = 'eager';
          this.querySelector('[data-equipment-enlarged]').replaceChildren(image);
          this.dialog.showModal();
        }, options);
      });
      this.querySelector('[data-equipment-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.zoomTrigger?.focus(), options);
      let startX;
      this.querySelector('.wacc-equipment-gallery__stage').addEventListener('touchstart', (event) => {
        startX = event.target.closest('video, iframe, button') ? undefined : event.touches[0].clientX;
      }, { ...options, passive: true });
      this.querySelector('.wacc-equipment-gallery__stage').addEventListener('touchend', (event) => {
        if (startX === undefined || this.dialog.open) return;
        const distance = event.changedTouches[0].clientX - startX;
        if (Math.abs(distance) > 60) {
          const index = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          this.select((index + (distance < 0 ? 1 : -1) + this.tabs.length) % this.tabs.length);
        }
        startX = undefined;
      }, { ...options, passive: true });
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if (i !== index) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
          // Removing the embed stops third-party audio without cross-origin messaging.
          panel.querySelector('[data-equipment-player]')?.replaceChildren();
          if (panel.captionUrl) {
            URL.revokeObjectURL(panel.captionUrl);
            panel.captionUrl = undefined;
          }
          const play = panel.querySelector('[data-equipment-play]');
          if (play) play.hidden = false;
        }
      });
      this.querySelectorAll('[data-equipment-transcript]').forEach((text) => {
        text.hidden = text.dataset.equipmentTranscript !== this.tabs[index].dataset.equipmentThumb;
      });
      this.querySelector('[data-equipment-status]').textContent = `View ${index + 1} of ${this.tabs.length}`;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.panels?.forEach((panel) => {
        panel.querySelectorAll('video').forEach((video) => video.pause());
        panel.querySelector('[data-equipment-player]')?.replaceChildren();
        if (panel.captionUrl) URL.revokeObjectURL(panel.captionUrl);
        panel.captionUrl = undefined;
      });
    }
  });
}
